import { VENDOR_WITHDRAWALS, VENDOR_WITHDRAWALS_SHOW, } from "../endpoints";
import api from "../api";

export default {
    index(query) {
        let url = new URL(VENDOR_WITHDRAWALS);

        if (query)
            url.search = new URLSearchParams(query).toString();

        return api.get(url);
    },

    show(vendorWithdrawal = null) {
        if (vendorWithdrawal === null) return;

        const url = VENDOR_WITHDRAWALS_SHOW.replace(":vendorWithdrawal", vendorWithdrawal);

        return api.get(url);
    },

    update(vendorWithdrawal, data) {
        if (vendorWithdrawal === null) return;

        const url = VENDOR_WITHDRAWALS_SHOW.replace(":vendorWithdrawal", vendorWithdrawal);

        return api.put(url, data);
    },

    generateWithdrawals() {
        let url = new URL(VENDOR_WITHDRAWALS);

        return api.post(url);
    }
}